import { connect } from 'react-redux';

// Selectors
import {
  getSelectedProduct,
  getSelectedHour,
  getSelectedMonth,
  getSelectedDay,
} from '../../selectors';

// Components
import DateInfo from './component';
import { getSelectedYear } from 'components/emissions-demo/selectors';

const mapStateToProps = state => ({
  selectedYear: getSelectedYear(state),
  selectedProduct: getSelectedProduct(state),
  selectedMonth: getSelectedMonth(state),
  selectedDay: getSelectedDay(state),
  selectedHour: getSelectedHour(state),
  selectedDate: state.forecastDemo.state.date,
  selectedZone: state.forecastDemo.state.zone,
  selectedTimeZone: state.forecastDemo.state.timezone,
  selectedWeekDay: state.forecastDemo.state.weekDay
});

export default connect(mapStateToProps)(DateInfo);



// WEBPACK FOOTER //
// ./src/components/forecast-demo/components/date-info/index.js